import { render, staticRenderFns } from "./scanRecord.vue?vue&type=template&id=70432884&scoped=true&"
import script from "./scanRecord.vue?vue&type=script&lang=js&"
export * from "./scanRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70432884",
  null
  
)

export default component.exports